// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const steelix: PokeData = {
  "id": 208,
  "name": "steelix",
  "height": 92,
  "weight": 4000,
  "base_experience": 179,
  "types": [
    PokeType.STEEL,
    PokeType.GROUND
  ],
  "api_moves": [
    "bind",
    "slam",
    "tackle",
    "double-edge",
    "rock-throw",
    "dig",
    "rage",
    "screech",
    "harden",
    "rock-slide",
    "curse",
    "sandstorm",
    "rollout",
    "dragon-breath",
    "iron-tail",
    "crunch",
    "mud-sport",
    "rock-tomb",
    "sand-tomb",
    "gyro-ball",
    "magnet-rise",
    "rock-polish",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "stone-edge",
    "stealth-rock",
    "autotomize",
    "smack-down",
    "bulldoze",
    "high-horsepower"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "rock-slide",
    "curse",
    "sandstorm",
    "dragon-breath",
    "crunch",
    "rock-tomb",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "stealth-rock",
    "meteor-mash"
  ],
  "evolution_chain": {
    "id": 41,
    "item": null,
    "species": [
      {
        "name": "onix",
        "order": 103,
        "types": [
          PokeType.ROCK,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "steelix",
        "order": 104,
        "types": [
          PokeType.STEEL,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 95,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 190,
    "speed": 55,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
